import React from 'react'
import classnames from 'classnames'
import AccountInformation from '@SiteContainers/AccountInformation'
import AccountUsersTable from '@SiteContainers/AccountUsersTable'
import WorkspacesTable from '@SiteContainers/WorkspacesTable'
import ProviderSettings from '@SiteContainers/ProviderSettings'
import CreditsPurchase from '@SiteContainers/CreditsPurchase'
import UserProfile from '@SiteContainers/UserProfile'
import Statistics from '@SiteContainers/Statistics'
import SettingsMenu from './SettingsMenu'

import './SettingsMain.scss'

interface SettingsMainProps {
  readonly currentAccountId: number
  readonly activeSettings: string
  readonly userIsAccountAdmin: boolean
  readonly showSettingsWithFullAccountUserView: boolean
  readonly showSettingsWithFullWorkspaceView: boolean
  setActiveSettings(activeSettings: string): void
  setOpenedAccountUserId(openedAccountUserId: number): void
  setOpenedWorkspaceId(openedWorkspaceId: number): void
}

const SettingsMain: React.FC<SettingsMainProps> = props => {
  const {
    userIsAccountAdmin,
    activeSettings,
    currentAccountId,
    showSettingsWithFullAccountUserView,
    showSettingsWithFullWorkspaceView,
  } = props

  const userProfileSettingsActive = activeSettings === 'profile'
  const accountUsersSettingsActive = activeSettings === 'users'
  const accountInformationSettingsActive = activeSettings === 'information'
  const accountWorkspacesSettingsActive = activeSettings === 'workspaces'
  const accountProviderSettingsActive = activeSettings === 'providers'
  const accountCreditsPurchaseActive = activeSettings === 'credits'
  const statisticsActive = activeSettings === 'statistics'

  const renderSettingsHeader = () => {
    return (
      <div className="SettingsMain__header">
        Settings
        <span className="SettingsMain__subheader">
          Manage general settings related to your account
        </span>
      </div>
    )
  }

  const renderSettingsBody = () => {
    return (
      <div className="SettingsMain__body">
        <SettingsMenu
          currentAccountId={currentAccountId}
          activeSettings={activeSettings}
          setActiveSettings={props.setActiveSettings}
          userIsAccountAdmin={userIsAccountAdmin}
        />
        {accountInformationSettingsActive && renderAccountInformation()}
        {accountUsersSettingsActive && renderAccountUsersTable()}
        {accountWorkspacesSettingsActive && renderWorkspacesTable()}
        {accountProviderSettingsActive && renderProviderSettings()}
        {userProfileSettingsActive && renderUserProfile()}
        {accountCreditsPurchaseActive && renderCreditsPurchase()}
        {statisticsActive && renderStatistics()}
      </div>
    )
  }

  const renderAccountInformation = () => {
    return (
      <AccountInformation />
    )
  }

  const renderAccountUsersTable = () => {
    return (
      <AccountUsersTable
        setOpenedAccountUserId={props.setOpenedAccountUserId}
      />
    )
  }

  const renderWorkspacesTable = () => {
    return (
      <WorkspacesTable
        setOpenedWorkspaceId={props.setOpenedWorkspaceId}
      />
    )
  }

  const renderProviderSettings = () => {
    return (
      <ProviderSettings />
    )
  }

  const renderUserProfile = () => {
    return (
      <UserProfile />
    )
  }

  const renderCreditsPurchase = () => {
    return (
      <CreditsPurchase />
    )
  }

  const renderStatistics = () => {
    return (
      <Statistics />
    )
  }

  return (
    <div className={classnames(
      'SettingsMain',
      { 'SettingsMain__full-right-sidebar-view': showSettingsWithFullAccountUserView || showSettingsWithFullWorkspaceView }
    )}>
      {renderSettingsHeader()}
      {renderSettingsBody()}
    </div>
  )
}

export default SettingsMain
